import BaseApi from './base.api'
import ApiService from '@services/api.service'


export default {
    ...BaseApi,
    ...{
        resource: 'areas'
    },

    toggleStatus(payload) {
        return ApiService.post(`/${this.resource}/${payload.id}/toggle-status`, payload);
    }
}
